const initState = {}

const projectReducer = (state = initState, action) => {
  switch (action.type) {
    case 'UPDATE_CREATECHOICES_SUCCESS':
      //console.log('update createchoices success');
      return state;
    case 'UPDATE_CREATECHOICES_ERROR':
      //console.log('update createchoices error');
      return state;
    case 'UPDATE_VOTEROUND_SUCCESS':
      //console.log('update voteround success');
      return state;
    case 'UPDATE_VOTEROUND_ERROR':
      //console.log('update voteround error');
      return state;
    case 'UPDATE_VOTE_SUCCESS':
      //console.log('update vote success');
      return state;
    case 'UPDATE_VOTE_ERROR':
      //console.log('update vote error');
      return state;
    case 'UPDATE_WINNERSLIST_SUCCESS':
      //console.log('update winnerslist success');
      return state;
    case 'UPDATE_WINNERSLIST_ERROR':
      //console.log('update winnerslist error');
      return state;
    case 'UPDATE_ROUND_SUCCESS':
      //console.log('update round success');
      return state;
    case 'UPDATE_ROUND_ERROR':
      //console.log('update round error');
      return state;
    case 'UPDATE_WINNERSROUND_SUCCESS':
      //console.log('update winnersround success');
      return state;
    case 'UPDATE_PLAYERS_ERROR':
      //console.log('update winnersround error');
      return state;
    case 'UPDATE_WINNERS_SUCCESS':
      //console.log('update winners success');
      return state;
    case 'UPDATE_WINNERS_ERROR':
      //console.log('update winners error');
      return state;
    case 'UPDATE_ROUNDONE_SUCCESS':
      //console.log('update round one success');
      return state;
    case 'UPDATE_ROUNDONE_ERROR':
      //console.log('update round one error');
      return state;
    case 'UPDATE_ROUND_SUCCESS':
      //console.log('update round success');
      return state;
    case 'UPDATE_ROUND_ERROR':
      //console.log('update round error');
      return state;
    case 'UPDATE_PLAYERS_SUCCESS':
      //console.log('update players success');
      return state;
    case 'UPDATE_PLAYERS_ERROR':
      //console.log('update players error');
      return state;
    case 'CREATE_GAME_SUCCESS':
      //console.log('create game success');
      return state;
    case 'CREATE_GAME_ERROR':
      //console.log('create game error');
      return state;
    case 'BACKUP_GAME_SUCCESS':
      //console.log('backup game success');
      return state;
    case 'BACKUP_GAME_ERROR':
      //console.log('backup game error');
      return state;
    case 'DELETE_GAME_SUCCESS':
      //console.log('delete game success');
      return state;
    case 'DELETE_GAME_ERROR':
      //console.log('delete game error');
      return state;
    case 'CREATE_PROJECT_SUCCESS':
      //console.log('create project success');
      return state;
    case 'CREATE_PROJECT_ERROR':
      //console.log('create project error');
      return state;
    case 'UPDATE_DISTANCES_SUCCESS':
      //console.log('update distances success');
      return state;
    case 'UPDATE_DISTANCES_ERROR':
      //console.log('update distances error');
      return state;
    case 'UPDATE_ADDRESS_SUCCESS':
      //console.log('update address success');
      return state;
    case 'UPDATE_ADDRESS_ERROR':
      //console.log('update address error');
      return state;
    case 'ADD_POINTS_SUCCESS':
      //console.log('add points success');
      return state;
    case 'ADD_POINTS_ERROR':
      //console.log('add points error');
      return state;
    case 'AD_CLICK_SUCCESS':
      //console.log('ad click success');
      return state;
    case 'AD_CLICK_ERROR':
      //console.log('ad click error');
      return state;
    case 'BACKUP_ISSUE_SUCCESS':
      //console.log('backup issue success');
      return state;
    case 'BACKUP_ISSUE_ERROR':
      //console.log('backup issue error');
      return state;
    case 'CLOSE_ISSUE_SUCCESS':
      //console.log('close issue success');
      return state;
    case 'CLOSE_ISSUE_ERROR':
      //console.log('close issue error');
      return state;
    case 'DELETE_ISSUE_SUCCESS':
      //console.log('delete issue success');
      return state;
    case 'DELETE_ISSUE_ERROR':
      //console.log('delete issue error');
      return state;
    case 'DELETE_GUEST_USER_SUCCESS':
      //console.log('delete guest user success');
      return state;
    case 'DELETE_GUEST_USER_ERROR':
      //console.log('delete guest user error');
      return state;
    case 'DELETE_GUEST_USER_FAVS_SUCCESS':
      //console.log('delete guest user favs success');
      return state;
    case 'DELETE_GUEST_USER_FAVS_ERROR':
      //console.log('delete guest user favs error');
      return state;
    case 'UPDATE_REVIEW_COUNT_SUCCESS':
      //console.log('update review count success');
      return state;
    case 'UPDATE_REVIEW_COUNT_ERROR':
      //console.log('update review count error');
      return state;
    case 'CREATE_MESSAGE_SUCCESS':
      //console.log('create message success');
      return state;
    case 'CREATE_MESSAGE_ERROR':
      //console.log('create message error');
      return state;
    case 'ADD_MESSAGE_SUCCESS':
      //console.log('add message success');
      return state;
    case 'ADD_MESSAGE_ERROR':
      //console.log('add message error');
      return state;
    case 'ADD_TICKET_SUCCESS':
      //console.log('add ticket success');
      return state;
    case 'ADD_TICKET_ERROR':
      //console.log('add ticket error');
      return state;
    case 'ADD_ISSUE_SUCCESS':
      //console.log('add issue success');
      return state;
    case 'ADD_ISSUE_ERROR':
      //console.log('add issue error');
      return state;
    case 'ADD_REVIEW_TICKET_SUCCESS':
      //console.log('add review ticket success');
      return state;
    case 'ADD_REVIEW_TICKET_ERROR':
      //console.log('add review ticket error');
      return state;
    case 'ADD_ISSUE_TICKET_SUCCESS':
      //console.log('add issue ticket success');
      return state;
    case 'ADD_ISSUE_TICKET_ERROR':
      //console.log('add issue ticket error');
      return state;
    case 'ADD_ADMIN_TICKET_SUCCESS':
      //console.log('add admin ticket success');
      return state;
    case 'ADD_ADMIN_TICKET_ERROR':
      //console.log('add admin ticket error');
      return state;
    case 'ADD_ADMIN_REVIEW_TICKET_SUCCESS':
      //console.log('add admin review ticket success');
      return state;
    case 'ADD_ADMIN_REVIEW_TICKET_ERROR':
      //console.log('add admin review ticket error');
      return state;
    case 'ADD_ADMIN_ISSUE_TICKET_SUCCESS':
      //console.log('add admin issue ticket success');
      return state;
    case 'ADD_ADMIN_ISSUE_TICKET_ERROR':
      //console.log('add admin issue ticket error');
      return state;
    case 'ADD_REVIEW_MESSAGE_SUCCESS':
      //console.log('add review message success');
      return state;
    case 'ADD_REVIEW_MESSAGE_ERROR':
      //console.log('add review message error');
      return state;
    case 'ADD_ISSUE_MESSAGE_SUCCESS':
      //console.log('add issue message success');
      return state;
    case 'ADD_ISSUE_MESSAGE_ERROR':
      //console.log('add issue message error');
      return state;
    case 'BACKUP_ISSUE_MESSAGE_SUCCESS':
      //console.log('backup issue message success');
      return state;
    case 'BACKUP_ISSUE_MESSAGE_ERROR':
      //console.log('backup issue message error');
      return state;
    case 'ADD_USER_REVIEW_SUCCESS':
      //console.log('add user review success');
      return state;
    case 'ADD_USER_REVIEW_ERROR':
      //console.log('add user review error');
      return state;
    case 'ADD_REVIEW_SUCCESS':
      //console.log('add review success');
      return state;
    case 'ADD_REVIEW_ERROR':
      //console.log('add review error');
      return state;
    case 'BACKUP_REVIEW_SUCCESS':
      //console.log('backup review success');
      return state;
    case 'BACKUP_REVIEW_ERROR':
      //console.log('backup review error');
      return state;
    case 'DELETE_REVIEW_SUCCESS':
      //console.log('delete review success');
      return state;
    case 'DELETE_REVIEW_ERROR':
      //console.log('delete review error');
      return state;
    case 'BACKUP_USER_REVIEW_SUCCESS':
      //console.log('backup user review success');
      return state;
    case 'BACKUP_USER_REVIEW_ERROR':
      //console.log('backup user review error');
      return state;
    case 'DELETE_USER_REVIEW_SUCCESS':
      //console.log('delete user review success');
      return state;
    case 'DELETE_USER_REVIEW_ERROR':
      //console.log('delete user review error');
      return state;
    case 'ADD_PENDING_REVIEW_SUCCESS':
      //console.log('add pending review success');
      return state;
    case 'ADD_PENDING_REVIEW_ERROR':
      //console.log('add pending review error');
      return state;
    case 'LINK_REVIEW_SUCCESS':
      //console.log('link review success');
      return state;
    case 'LINK_REVIEW_ERROR':
      //console.log('link review error');
      return state;
    case 'BACKUP_MESSAGE_SUCCESS':
      //console.log('backup message success');
      return state;
    case 'BACKUP_MESSAGE_ERROR':
      //console.log('backup message error');
      return state;
    case 'BACKUP_REVIEW_MESSAGE_SUCCESS':
      //console.log('backup review message success');
      return state;
    case 'BACKUP_REVIEW_MESSAGE_ERROR':
      //console.log('backup review message error');
      return state;
    case 'DELETE_MESSAGE_SUCCESS':
      //console.log('delete message success');
      return state;
    case 'DELETE_MESSAGE_ERROR':
      //console.log('delete message error');
      return state;
    case 'DELETE_CHAT_SUCCESS':
      //console.log('delete chat success');
      return state;
    case 'DELETE_CHAT_ERROR':
      //console.log('delete chat error');
      return state;
    case 'DELETE_REVIEW_CHAT_SUCCESS':
      //console.log('delete review chat success');
      return state;
    case 'DELETE_REVIEW_CHAT_ERROR':
      //console.log('delete review chat error');
      return state;
    case 'DELETE_ISSUE_CHAT_SUCCESS':
      //console.log('delete issue chat success');
      return state;
    case 'DELETE_ISSUE_CHAT_ERROR':
      //console.log('delete issue chat error');
      return state;
    case 'DELETE_ISSUE_MESSAGE_SUCCESS':
      //console.log('delete issue message success');
      return state;
    case 'DELETE_ISSUE_MESSAGE_ERROR':
      //console.log('delete issue message error');
      return state;
    case 'DELETE_REVIEW_MESSAGE_SUCCESS':
      //console.log('delete review message success');
      return state;
    case 'DELETE_REVIEW_MESSAGE_ERROR':
      //console.log('delete review message error');
      return state;
    case 'DELETE_ADMIN_MESSAGE_SUCCESS':
      //console.log('delete admin message success');
      return state;
    case 'DELETE_ADMIN_MESSAGE_ERROR':
      //console.log('delete admin message error');
      return state;
    case 'DELETE_ADMIN_REVIEW_MESSAGE_SUCCESS':
      //console.log('delete admin review message success');
      return state;
    case 'DELETE_ADMIN_REVIEW_MESSAGE_ERROR':
      //console.log('delete admin review message error');
      return state;
    case 'DELETE_ADMIN_ISSUE_MESSAGE_SUCCESS':
      //console.log('delete admin issue message success');
      return state;
    case 'DELETE_ADMIN_ISSUE_MESSAGE_ERROR':
      //console.log('delete admin issue message error');
      return state;
    case 'ADD_ADMIN_MESSAGE_SUCCESS':
      //console.log('add admin message success');
      return state;
    case 'ADD_ADMIN_MESSAGE_ERROR':
      //console.log('add admin message error');
      return state;
    case 'EDIT_PROJECT_SUCCESS':
      //console.log('edit project success');
      return state;
    case 'EDIT_PROJECT_ERROR':
      //console.log('edit project error');
      return state;
    case 'EDIT_CREATE_PROJECT_SUCCESS':
      //console.log('edit create project success');
      return state;
    case 'EDIT_CREATE_PROJECT_ERROR':
      //console.log('edit create project error');
      return state;
    case 'PENDING_EDIT_PROJECT_SUCCESS':
      //console.log('pending edit project success');
      return state;
    case 'PENDING_EDIT_PROJECT_ERROR':
      //console.log('pending edit project error');
      return state;
    case 'ADMIN_EDIT_PROJECT_SUCCESS':
      //console.log('admin edit project success');
      return state;
    case 'ADMIN_EDIT_PROJECT_ERROR':
      //console.log('admin edit project error');
      return state;
    case 'ADMIN_CONFIRM_EDIT_PROJECT_SUCCESS':
      //console.log('admin confirm edit project success');
      return state;
    case 'ADMIN_CONFIRM_EDIT_PROJECT_ERROR':
      //console.log('admin confirm edit project error');
      return state;
    case 'ADMIN_CONFIRM_PROJECT_SUCCESS':
      //console.log('admin confirm project success');
      return state;
    case 'ADMIN_CONFIRM_PROJECT_ERROR':
      //console.log('admin confirm project error');
      return state;
    case 'BACKUP_PROJECT_SUCCESS':
      //console.log('backup project success');
      return state;
    case 'BACKUP_PROJECT_ERROR':
      //console.log('backup project error');
      return state;
    case 'ADMIN_DELETE_PROJECT_SUCCESS':
      //console.log('admin delete project success');
      return state;
    case 'ADMIN_DELETE_PROJECT_ERROR':
      //console.log('admin delete project error');
      return state;
    case 'ADMIN_FULL_DELETE_PROJECT_SUCCESS':
      //console.log('admin full delete project success');
      return state;
    case 'ADMIN_FULL_DELETE_PROJECT_ERROR':
      //console.log('admin full delete project error');
      return state;
    case 'ADMIN_DELETE_CREATE_PROJECT_SUCCESS':
      //console.log('admin delete create project success');
      return state;
    case 'ADMIN_DELETE_CREATE_PROJECT_ERROR':
      //console.log('admin delete create project error');
      return state;
    default:
      return state;
  }
};

export default projectReducer;